import { useTranslation } from 'react-i18next';
import { Command } from 'cmdk';

import { MAGIC_SEARCH_GROUP_CLASS } from '../constants';
import { MagicSearchSectionsProps } from '../magic-search-palette.type';

import { MagicSearchBookingItem } from './magic-search-booking-item';
import { MagicSearchEventItem } from './magic-search-event-item';
import { MagicSearchVenueGroup } from './magic-search-venue-group';

export const MagicSearchSections = ({ results, onOpen }: MagicSearchSectionsProps) => {
  const { t } = useTranslation();
  const { events, venues, bookings } = results;

  return (
    <>
      {events.length > 0 && (
        <Command.Group
          heading={t('menu:events')}
          className={MAGIC_SEARCH_GROUP_CLASS}
          data-testid='magic-search--events'>
          {events.map((event) => (
            <MagicSearchEventItem key={event.id} event={event} onOpen={onOpen} />
          ))}
        </Command.Group>
      )}
      {venues.length > 0 && (
        <Command.Group
          heading={t('menu:magicSearchVenues')}
          className={MAGIC_SEARCH_GROUP_CLASS}
          data-testid='magic-search--venues'>
          {venues.map((venue) => (
            <MagicSearchVenueGroup key={venue.id} venue={venue} onOpen={onOpen} />
          ))}
        </Command.Group>
      )}
      {bookings.length > 0 && (
        <Command.Group
          heading={t('menu:magicSearchBookings')}
          className={MAGIC_SEARCH_GROUP_CLASS}
          data-testid='magic-search--bookings'>
          {bookings.map((booking) => (
            <MagicSearchBookingItem key={booking.id} booking={booking} onOpen={onOpen} />
          ))}
        </Command.Group>
      )}
    </>
  );
};
